import { Modals, MessageBoxTypes } from '@ui5/webcomponents-react';

export const createMessageBox = container => {
  const messageBoxFactory = type => props => {
    return new Promise(resolve => {
      Modals.showMessageBox(
        {
          ...props,
          type,
          onClose: evt => {
            resolve(evt.detail.action);
          },
        },
        container || document.body,
      );
    });
  };
  return {
    success: messageBoxFactory(MessageBoxTypes.Success),
    error: messageBoxFactory(MessageBoxTypes.Error),
    warn: messageBoxFactory(MessageBoxTypes.Warning),
    warning: messageBoxFactory(MessageBoxTypes.Warning),
    confirm: messageBoxFactory(MessageBoxTypes.Confirm),
    info: messageBoxFactory(MessageBoxTypes.Information),
  };
};

export const createMessageBoxForMFE = appName =>
  createMessageBox(document.getElementById(`${appName}-application-container`)?.shadowRoot);
